import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import Section01 from './components/section01';
import Section02 from './components/section02';
import Section03 from './components/section03';
import GsapdGroupb from './gsapdGroupb';
import { CanvasKeyFrames } from '@/utils/canvaskeyframes';
import { heightListen } from '@/utils/animationUtils';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { handleDynamicPath } from '@/utils/handleDynamicPath';

gsap.registerPlugin(ScrollTrigger);
const textList = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
let preTexts = '2016';

const PageConPc = dynamic(() => import('@/components/ProductDelta/deltamaxnew/indexDynamic'), {
    ssr: true,
});

export default function DeltaMax() {
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const { useState, useEffect, useRef, gloproductlist, useRouter } = useGlobal();
    const { locale } = useRouter();
    const ref = useRef();
    const section3Ref = useRef();
    const [currentTextList, setCurrentTextList] = useState(['2', '0', '1', '6']);
    const [batteryNumber, setBatteryNumber] = useState('1');

    const product: any = {
        us: ['product_ps_delta_delta_mini', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_pro'],
        cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        za: ['product_ps_delta_delta_1300', 'product_ps_delta_delta_pro', 'product_ps_river_river_pro_720'],
        cis: ['product_ps_delta_delta_2', 'product_ps_delta_delta_pro', 'product_ps_river_river_256'],
        eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_pro'],
        br: ['product_ps_delta_delta_2', 'product_ps_delta_delta_2_max', 'product_ps_delta_delta_pro_plus'],
    };

    const otherProductData = getDetaileMoreProducts(gloproductlist, product[locale] || product.us);

    const createImgs = (imageCount: number) => {
        const imageEleArr: any[] = [];
        return new Promise((resolve, reject) => {
            let loadImageCount = 0;
            for (let i = 0; i < imageCount; i++) {
                const imageEle = new window.Image();
                imageEleArr.push(imageEle);
                imageEle.onload = function () {
                    loadImageCount++;
                    if (loadImageCount >= imageCount) {
                        // 此时图片全部加载完成
                        resolve(imageEleArr);
                    }
                };
                imageEle.onerror = reject;

                imageEle.src = handleDynamicPath(`/media/deltamax/pc/P2-P4/images/seq_0_${i}.png`);
            }
        });
    };

    useEffect(() => {
        /**
         * P1 - P4 start
         */
        // 1、kv文字浮现
        gsap.to('.section01 .text-wrapper', {
            opacity: 1,
            duration: 2,
            delay: 2,
        });

        let canvasKeyFramesInstance: any = null;
        // P1-P4主时间线
        const imageCount = 200;
        const framesCount = imageCount - 1;
        const TL1 = gsap.timeline({
            scrollTrigger: {
                trigger: '.P1_P4_sticky_wrapper',
                start: 'top top',
                end: '+=400%',
                scrub: 0.3,
                //markers: true,
            },
        });
        TL1.to('.section01 > .animation', {
            y: '-100vh',
            ease: 'none',
            direction: 1,
        }).to(
            '.section02 > .animation',
            {
                opacity: 1,
                ease: 'none',
                direction: 0.1,
            },
            0,
        );
        TL1.to('.section02 > .animation', {
            scale: 1.2,
            opacity: 0,
            direction: 0.5,
            onStart() {
                // 预加载序列帧图片
                if (canvasKeyFramesInstance) return;
                const container = document.querySelector('.section03 .canvas-wrapper');
                if (!container) return;

                createImgs(imageCount).then((imgArr) => {
                    canvasKeyFramesInstance = new CanvasKeyFrames(container, 'array', imgArr, {
                        width: 840,
                        height: 500,
                        fps: 60,
                    });
                });
            },
        });
        TL1.to(
            '.section03 > .animation',
            {
                direction: 0.2,
                opacity: 1,
            },
            '-=0.2',
        );

        // 播放序列帧
        TL1.to(
            '.section03 > .animation',
            {
                direction: 0.33,
                onUpdate() {
                    const startFarame = 0;
                    const endFarame = framesCount * 0.33;
                    const progress = this.progress();
                    const currentFarame = Math.floor((endFarame - startFarame) * progress + startFarame);
                    canvasKeyFramesInstance && canvasKeyFramesInstance.goto(currentFarame);
                    if (preTexts === '2016') return;
                    setCurrentTextList('2016'.split(''));
                    setBatteryNumber('1');

                    if (preTexts === '4032') {
                        section3Ref.current?.animationReverse();
                    }
                    preTexts = '2016';
                },
            },
            '-=0.2',
        );
        TL1.to('.section03 > .animation', {
            direction: 0.33,
            onUpdate() {
                const startFarame = framesCount * 0.33;
                const endFarame = framesCount * 0.67;
                const progress = this.progress();
                const currentFarame = Math.floor((endFarame - startFarame) * progress + startFarame);
                canvasKeyFramesInstance && canvasKeyFramesInstance.goto(currentFarame);
                if (preTexts === '4032') return;
                setCurrentTextList('4032'.split(''));
                setBatteryNumber('1');
                if (preTexts === '2016') {
                    section3Ref.current?.animation();
                }
                preTexts = '4032';
            },
        });
        TL1.to('.section03 > .animation', {
            direction: 0.33,
            onUpdate() {
                const startFarame = framesCount * 0.67;
                const endFarame = framesCount * 1;
                const progress = this.progress();
                const currentFarame = Math.floor((endFarame - startFarame) * progress + startFarame);
                canvasKeyFramesInstance && canvasKeyFramesInstance.goto(currentFarame);
                if (preTexts === '6048') return;
                setCurrentTextList('6048'.split(''));
                setBatteryNumber('2');
                preTexts = '6048';
            },
        });
        TL1.to('.section03 > .animation', {
            direction: 1,
        });

        const TL2 = gsap.timeline({
            scrollTrigger: {
                trigger: '.P1_P4_sticky_wrapper',
                start: `top+=${layoutH * 3} top`,
                end: '+=200%',
                scrub: 0.3,
                //markers: true,
                onEnter: function () {
                    console.log('TL2', 222);
                },
            },
        });
        TL2.to('.section04 > .gsapdGroupb', {
            y: -layoutH,
            duration: 1,
        })
            .to('.section04 > .gsapdGroupb .a-msg-box-out', {
                opacity: 1,
                duration: 0.5,
            })
            .to('.section04 > .gsapdGroupb .a-msg-box', {
                y: -100,
                opacity: 1,
                duration: 0.5,
            });

        const deltaMaxWrapper = ref.current;
        const listener = heightListen(deltaMaxWrapper, () => {
            ScrollTrigger.refresh();
            ScrollTrigger.update();
        });

        return () => {
            listener.clear();
            ScrollTrigger.getAll().forEach((instance) => {
                instance?.kill();
            });
        };
    }, []);

    return (
        <div ref={ref} className={css.delta_max}>
            {/* P1 - P4 */}
            <div className="P1_P4_sticky_wrapper">
                <div className="P1_P4_sticky_container">
                    <div className="blockWrapper section01">
                        {/* kv视频 */}
                        <Section01 />
                    </div>
                    <div className="blockWrapper section02">
                        {/* 一图看懂 */}
                        <Section02 />
                    </div>
                    <div className="blockWrapper section03">
                        {/* 扩展容量-数字-螺旋背景图 */}
                        <Section03 ref={section3Ref} textList={textList} currentList={currentTextList} batteryNumber={batteryNumber} />
                    </div>
                    <div className="blockWrapper section04">
                        <GsapdGroupb />
                    </div>
                </div>
            </div>
            <PageConPc otherProductData={otherProductData} />
        </div>
    );
}
